



































































































import Vue from 'vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-tw';
const Ripple = require('vue-ripple-directive');
import moment from 'moment';
import axios from 'axios';
import { mapState, mapActions, mapMutations } from 'vuex';
import {
  MonthlyHourReport,
  StatRow,
} from './types';

interface MonthlyHourReport2 extends MonthlyHourReport {
  dateStr?: string;
}
export default Vue.extend({
  components: {
    DatePicker,
  },
  directives: {
    Ripple,
  },
  data() {
    const date = moment().valueOf();
    let monitor: string | undefined;
    let monitorType: string | undefined;
    return {
      display: false,
      columns: Array<any>(),
      statRows: Array<StatRow>(),
      rows: Array<any>(),
      form: {
        monitor,
        date,
        monitorType,
      },
    };
  },
  computed: {
    ...mapState('monitors', ['monitors']),
    ...mapState('monitorTypes', ['monitorTypes']),
    canQuery(): boolean {
      if (this.form.monitor && this.form.date) return true;
      else return false;
    },
  },
  async mounted() {
    await this.fetchMonitors();
    if(this.monitors.length !== 0) {
      this.form.monitor = this.monitors[0]._id;
    }

    await this.fetchMonitorTypes();
    if (this.monitorTypes.length !== 0) {
      this.form.monitorType = 'PM25';
    }
  },
  methods: {
    ...mapActions('monitorTypes', ['fetchMonitorTypes']),
    ...mapActions('monitors', ['fetchMonitors']),
    ...mapMutations(['setLoading']),
    async query() {
      const url = `/MonthlyHourReport/${this.form.monitor}/${this.form.monitorType}/${this.form.date}`;
      this.setLoading({ loading: true });
      try {
        const res = await axios.get(url);
        this.display = true;
        this.handleReport(res.data);
      } finally {
        this.setLoading({ loading: false });
      }
    },
    handleReport(report: MonthlyHourReport2) {
      this.columns.splice(0, this.columns.length);

      this.columns.push({
        key: 'dateStr',
        label: '日\\時間',
      });

      for (let i = 0; i < report.columnNames.length; i++) {
        this.columns.push({
          key: `cellData[${i}].v`,
          label: `${report.columnNames[i]}`,
          stickyColumn: true,
        });
      }
      for (const row of report.rows) {
        row.dateStr = moment(row.date).format('MM/DD');
      }
      this.rows = report.rows;
      this.statRows = report.statRows;
    },
  },
});
